export default function CreditCardIcon() {
    return (
        <svg
            width="57"
            height="56"
            viewBox="0 0 57 56"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M40.0003 38H16.9992C16.8719 38 16.7498 37.9332 16.6598 37.8143C16.5697 37.6954 16.5192 37.5342 16.5192 37.366V18.634C16.5192 18.4658 16.5697 18.3046 16.6598 18.1857C16.7498 18.0668 16.8719 18 16.9992 18H40.0008C40.1281 18 40.2502 18.0668 40.3402 18.1857C40.4302 18.3046 40.4808 18.4658 40.4808 18.634V37.366C40.4808 37.5342 40.4302 37.6954 40.3402 37.8143C40.2502 37.9332 40.1276 38 40.0003 38Z"
                fill="#0B7A75"
                opacity="0.1"
            />
            <path
                d="M40.02 24.1832H16.98C16.8527 24.1832 16.7306 24.1164 16.6406 23.9975C16.5506 23.8786 16.5 23.7174 16.5 23.5492V21.7741C16.5 21.606 16.5506 21.4447 16.6406 21.3258C16.7306 21.2069 16.8527 21.1401 16.98 21.1401H40.02C40.1473 21.1401 40.2694 21.2069 40.3594 21.3258C40.4494 21.4447 40.5 21.606 40.5 21.7741V23.5492C40.5 23.7174 40.4494 23.8786 40.3594 23.9975C40.2694 24.1164 40.1473 24.1832 40.02 24.1832Z"
                fill="#0B7A75"
            />
            <path
                d="M21.299 34.834H20.3645C19.9796 34.8325 19.6108 34.6299 19.3387 34.2705C19.0665 33.911 18.9131 33.4239 18.912 32.9156V31.6806C18.9131 31.1724 19.0665 30.6854 19.3385 30.326C19.6105 29.9666 19.9792 29.7639 20.364 29.7622H21.2985C21.6835 29.7635 22.0524 29.9661 22.3247 30.3255C22.5969 30.685 22.7504 31.1722 22.7515 31.6806V32.9156C22.7504 33.424 22.5969 33.9112 22.3247 34.2707C22.0524 34.6301 21.684 34.8327 21.299 34.834Z"
                fill="#0B7A75"
            />
            <path
                opacity="0.05"
                d="M56.5 28C56.5 43.464 43.964 56 28.5 56C13.036 56 0.5 43.464 0.5 28C0.5 12.536 13.036 0 28.5 0C43.964 0 56.5 12.536 56.5 28Z"
                fill="#0B7A75"
            />
        </svg>
    );
}
